import React, { useState } from 'react';
import { formatNumber } from '../../utils/formatters';
import '../../styles/Dashboard.css';

const StockCritico = ({ productos = [] }) => {
  const [paginaActual, setPaginaActual] = useState(1);
  const productosPorPagina = 5;

  if (!productos || productos.length === 0) {
    return (
      <div className="dashboard-widget">
        <h3 className="widget-title">Stock Crítico</h3>
        <div className="widget-empty">
          <p className="text-success">✓ Todos los productos tienen stock suficiente</p>
        </div>
      </div>
    );
  }

  const getStockLevel = (cantidad, minimo) => {
    const porcentaje = (cantidad / minimo) * 100;
    if (porcentaje <= 50) return 'critical';
    if (porcentaje <= 100) return 'warning';
    return 'normal';
  };

  // Calcular paginación
  const totalPaginas = Math.ceil(productos.length / productosPorPagina);
  const indiceInicio = (paginaActual - 1) * productosPorPagina;
  const indiceFin = indiceInicio + productosPorPagina;
  const productosPaginados = productos.slice(indiceInicio, indiceFin);

  const cambiarPagina = (nuevaPagina) => {
    if (nuevaPagina >= 1 && nuevaPagina <= totalPaginas) {
      setPaginaActual(nuevaPagina);
    }
  };

  return (
    <div className="dashboard-widget">
      <h3 className="widget-title">
        <span className="widget-icon">⚠️</span>
        Productos con Stock Crítico
      </h3>
      <div className="widget-body">
        <div className="stock-critico-list">
          {productosPaginados.map((producto, index) => {
            const nombre = producto.producto__nombre || producto.nombre;
            const stockActual = producto.stock || producto.cantidad_actual || 0;
            const stockMinimo = producto.stock_minimo || 0;
            const codigo = producto.producto__codigo || producto.codigo || '';
            const stockLevel = getStockLevel(stockActual, stockMinimo);
            
            return (
              <div key={codigo || index} className={`stock-item stock-${stockLevel}`}>
                <div className="stock-info">
                  <div className="stock-nombre">
                    {nombre}
                    {codigo && <span className="stock-codigo"> ({codigo})</span>}
                  </div>
                  <div className="stock-details">
                    <span className="stock-actual">
                      Stock: {formatNumber(stockActual)}
                    </span>
                    <span className="stock-minimo">
                      Mínimo: {formatNumber(stockMinimo)}
                    </span>
                  </div>
                </div>
                <div className="stock-badge">
                  {stockLevel === 'critical' && '🔴'}
                  {stockLevel === 'warning' && '🟡'}
                </div>
              </div>
            );
          })}
        </div>
        
        {/* Paginación */}
        {totalPaginas > 1 && (
          <div className="pagination">
            <button
              className="pagination-btn"
              onClick={() => cambiarPagina(paginaActual - 1)}
              disabled={paginaActual === 1}
            >
              ← Anterior
            </button>
            <div className="pagination-center">
              <span className="pagination-info">
                Página {paginaActual} de {totalPaginas}
              </span>
              <span className="pagination-total">
                Total de registros: {productos.length}
              </span>
            </div>
            <button
              className="pagination-btn"
              onClick={() => cambiarPagina(paginaActual + 1)}
              disabled={paginaActual === totalPaginas}
            >
              Siguiente →
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default StockCritico;

// Made with Bob
